import { datadogLogs } from "@datadog/browser-logs"
import { DefaultPrivacyLevel, datadogRum } from "@datadog/browser-rum"

export function initializeDatadog() {
  if (
    typeof window !== "undefined" && // ensures in browser
    !!process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
    !!process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN &&
    !!(process.env.NEXT_PUBLIC_DATADOG_SITE === "us5.datadoghq.com") &&
    (process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ||
      process.env.NEXT_PUBLIC_ENABLE_DATADOG_RUM === "true")
  ) {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: process.env.NEXT_PUBLIC_DATADOG_SITE,
      service: "web",
      env: process.env.NEXT_PUBLIC_VERCEL_ENV ?? "development",
      version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
      allowedTracingUrls: [
        (url) =>
          url.startsWith(process.env.NEXT_PUBLIC_RUNDOO_API_BASE_URL ?? ""),
        (url) =>
          url.includes(
            (process.env.NEXT_PUBLIC_RUNDOO_SEARCH_API_BASE_URL ?? "").replace(
              "https://",
              ""
            )
          ),
        (url) => url.includes("search3.rundoo.app"),
        (url) => url.includes("search4.rundoo.app"),
        (url) => url.includes("search5.rundoo.app"),
      ],
    })

    datadogLogs.init({
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: process.env.NEXT_PUBLIC_DATADOG_SITE,
      service: "web",
      env: process.env.NEXT_PUBLIC_VERCEL_ENV ?? "development",
      version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
      forwardConsoleLogs: ["error"],
    })
  }
}
